import { Button } from "@mui/material";
import { getData } from "../../utils/APIUtilities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faGoogle } from "@fortawesome/free-brands-svg-icons";
import { GWWarhammerIcon } from "../../utils/icons/BCPIcon";

const AUTH_HOSTED_UI = `https://${window.location.host}/`;

async function loginToOIC(_scope) {
  const { scope, responseType, identity_provider } = _scope;

  let redirectUrl = `${AUTH_HOSTED_UI}oauth2/idpresponse`;

  const url = await getData("/users/oicurl", {
    queryStringParameters: {
      provider: identity_provider,
      redirect_uri: redirectUrl,
      responseType: responseType.toUpperCase(),
      scope: scope.join(" "),
    },
  });

  window.location.assign(url);
}

export function oidButtonSX(identity_provider) {
  return identity_provider === "GamesWorkshop"
    ? {
        backgroundColor: "#fbca1b",
        borderColor: "#181a1c",
        color: "#181a1c",
        "&:hover": {
          backgroundColor: "#E2B618",
        },
      }
    : identity_provider === "Google"
    ? {
        backgroundColor: "#4285F4",
        color: "#FFF",
        "&:hover": {
          backgroundColor: "#3f7ce8",
        },
      }
    : identity_provider === "Facebook"
    ? {
        backgroundColor: "#4267b2",
        color: "#FFF",
        "&:hover": {
          backgroundColor: "#2955ad",
        },
      }
    : {};
}

export default function OICLoginButton({ setProcessing, oic_scope }) {
  const buttonSX = oidButtonSX(oic_scope?.amplify?.identity_provider);
  return (
    <Button
      variant="contained"
      color={
        oic_scope?.type === "auth0"
          ? "info"
          : oic_scope?.type === "lfgnexus"
          ? "secondary"
          : "warning"
      }
      sx={{ textTransform: "unset", ...buttonSX }}
      fullWidth
      onClick={async () => {
        setProcessing(true);
        await loginToOIC(oic_scope?.amplify);
      }}
      startIcon={
        oic_scope?.amplify?.identity_provider === "Google" ? (
          <FontAwesomeIcon icon={faGoogle} />
        ) : oic_scope?.amplify?.identity_provider === "Facebook" ? (
          <FontAwesomeIcon icon={faFacebook} />
        ) : oic_scope?.amplify?.identity_provider === "GamesWorkshop" ? (
          <GWWarhammerIcon />
        ) : null
      }
    >
      {oic_scope?.amplify?.identity_provider === "GamesWorkshop"
        ? "Continue with My Warhammer"
        : oic_scope?.amplify?.identity_provider === "Google" ||
          oic_scope?.amplify?.identity_provider === "Facebook"
        ? `Continue with ${oic_scope?.amplify?.identity_provider
            .replace(/([A-Z])/g, " $1")
            .trim()}`
        : oic_scope?.amplify?.identity_provider ||
          (oic_scope?.type === "auth0"
            ? "Auth0"
            : oic_scope?.type === "lfgnexus"
            ? "LFG Nexus"
            : "Open ID Connect")}
    </Button>
  );
}
